import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import BgImg from "../../../images/locationgcc/sa/web-sa/header.webp";
import Bannerfrom from "../../components/bannerfrom";

function Banner(props) {
  return (
    <div
      className="locationgcc_banner banner_hire_sa"
      style={{ backgroundImage: `url(${BgImg})` }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <div className="banenr_content">
              <div className="example" data-text="Dubai">
                <h1>
                  Web Development Company in <span>Saudi Arabia</span>
                </h1>
              </div>
              <p className="main_para">
                Ensure an impactful web presence by employing a full-fledged web
                application for your business today. Our web development company
                in Saudi Arabia commits to the excellence of businesses that aim
                to grow in this competitive digital market. We use the latest
                technology with a result-oriented strategy in our web
                development KSA that helps businesses increase their ROI by 2X.
              </p>
              <Link
                to="/contact"
                className="border_btn dark_btn"
                aria-label="TekRevol Contact"
              >
            Let’s Get Started!
              </Link>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <Bannerfrom />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Banner;
